<template>
  <div>
    <b-input-group class="filter-field">
      <b-input-group-prepend class="filter-icon filter-icon-prepend">
        <b-icon icon="search" />
      </b-input-group-prepend>

      <b-custom-input
        :style="width ? `width: ${width};` : ''"
        v-model="text"
        :placeholder="label"
        :size="size"
        :show-error-spacing="false"
        class="filter-input"
        @focus="focused = true"
        @blur="focused = false"
        @input="onInput"
      />

      <b-input-group-append v-if="text" class="filter-icon filter-icon-append">
        <b-icon icon="x" scale="1.8" @click="selectItem(null)" />
      </b-input-group-append>
    </b-input-group>

    <transition v-if="focused && filteredItems.length && (text || showListOnFocus)" name="fade" mode="out-in">
      <ul role="menu" class="dropdown-menu filter-dropdown">
        <b-dropdown-item-button
          v-for="(item, index) in filteredItems"
          :key="index"
          @mousedown.native="selectItem(item)"
        >
          {{ getItemText(item) }}
        </b-dropdown-item-button>
      </ul>
    </transition>
  </div>
</template>

<script>
import BCustomInput from '@/components/organisation/BCustomInput';

export default {
  name: 'FilterField',

  components: {
    BCustomInput,
  },

  props: {
    width: {
      type: String,
    },
    showListOnFocus: {
      type: Boolean,
    },
    label: {
      type: String,
    },
    items: {
      type: Array,
    },
    filterCallback: {
      type: Function,
    },
    textCallback: {
      type: Function,
    },
    size: {
      type: String,
      default: 'sm',
    },
  },

  data() {
    return {
      item: null,
      text: '',
      focused: false,
    };
  },

  computed: {
    filteredItems() {
      if (!this.items) {
        return [];
      }

      if (!this.text) {
        return this.items;
      }

      if (this.filterCallback) {
        return this.filterCallback(this.items, this.text);
      }

      const search = this.text ? this.text.trim().toLowerCase() : '';
      return search ? this.items.filter((item) => `${item}`.toLowerCase().includes(search)) : this.items;
    },
  },

  methods: {
    getItemText(item) {
      return this.textCallback ? this.textCallback(item) : item;
    },

    onInput(text) {
      this.item = null;
      this.$emit('input', text);
    },

    selectItem(newItem) {
      this.item = newItem;
      this.text = this.getItemText(newItem);
      this.$emit('input', this.text);
    },
  },

  watch: {
    item(nextValue, prevValue) {
      if (nextValue !== prevValue) {
        this.$emit('update:selected', nextValue);
      }
    },
  },
};
</script>

<style scoped>
.filter-field {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.filter-dropdown {
  display: block;
  max-height: 300px;
  overflow-y: scroll;
}

.filter-input >>> input {
  border: none;
}

.filter-input >>> input:focus {
  box-shadow: 0 0 0 0.25rem #6c757d6e;
  border-color: #97979f;
}

.filter-input {
  border-radius: 3em !important;
  box-shadow: 0px 3px 6px 2px #97979f6b;
}

/* These input styles work for size="sm" variant of input field */
.filter-input >>> input,
.filter-input.form-label-group >>> input:not(:placeholder-shown) {
  border-radius: 3em;
  padding: 0 3em;
  font-size: 1rem;
  line-height: 1.5em;
  height: 2.375em;
}

.filter-input >>> input::placeholder {
  color: #97979f;
  text-transform: uppercase;
}

.filter-icon {
  color: #3b4552;
  position: absolute;
  z-index: 5;
  top: 50%;
}

.filter-icon-prepend {
  transform: translate(100%, -50%);
}

.filter-icon-append {
  right: 0;
  transform: translate(-100%, -50%);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/organisation/FilterField.vue